import React, { useState } from 'react';
import { Helmet } from 'react-helmet'; // ▼▼▼ ADDED ▼▼▼
import { useLocation } from 'react-router-dom'; // ▼▼▼ ADDED ▼▼▼
import './Garden.css';

const RenovationEn = () => {
    const [lightboxImage, setLightboxImage] = useState(null);
    const { pathname } = useLocation(); // ▼▼▼ ADDED ▼▼▼

    // Function to open the lightbox
    const openLightbox = (imageSrc) => {
        setLightboxImage(imageSrc);
    };

    return (
        <>
            {/* ▼▼▼ ADDED THIS ENTIRE HELMET BLOCK ▼▼▼ */}
            <Helmet>
                <title>Comfort & History | Five Features | Kanazawa Stay Akebono</title>
                <meta name="description" content="Discover how a 150-year-old Kanazawa machiya was fully renovated to blend historic charm with modern luxury. Akebono features the latest amenities while preserving its timeless architecture." />
                <link rel="canonical" href={`https://kanazawa-stay-akebono.com${pathname}`} />
                <meta property="og:title" content="A Harmony of Tradition and Comfort | Kanazawa Stay Akebono" />
                <meta property="og:description" content="A fully renovated 150-year-old machiya, equipped with the latest kitchen, bath, and climate control, while preserving its charming beams and walls." />
                <meta property="og:url" content={`https://kanazawa-stay-akebono.com${pathname}`} />
                <meta property="og:image" content="https://kanazawa-stay-akebono.com/images/feature-renovation.jpg" />
            </Helmet>
            {/* ▲▲▲ ADDITION ENDS HERE ▲▲▲ */}        <div className="akebono-garden-page">

                {/* HERO Section */}
                <section className="akebono-garden-hero" style={{ backgroundImage: "url('/images/feature-renovation.jpg')" }}>
                    <div className="akebono-garden-hero-overlay">
                        <h1>A Harmony of Tradition and Comfort</h1>
                    </div>
                </section>

                {/* Section 1: Renovation Overview */}
                <section className="akebono-garden-culture">
                    <h2>Renovated with Comfort in Mind</h2>
                    <p>
                        Akebono is a Kanazawa Machiya with over 150 years of history. In 2019, it underwent a full renovation that preserved the traditional charm while introducing modern comforts.
                    </p>
                    <p>
                        From the earthen walls to exposed beams, the architecture retains its nostalgic appeal. Meanwhile, the latest air-conditioning and plumbing facilities ensure a stress-free and cozy stay.
                    </p>
                    <p>
                        With over 170㎡ of space, up to 8 guests can relax comfortably. It’s a retreat where the past and present come together to offer an unforgettable experience.
                    </p>
                    <div className="akebono-garden-gallery">
                        <img src="/images/room.jpg" alt="Interior view of Machiya" onClick={() => openLightbox('/images/room.jpg')} />
                        <img src="/images/renovation1.jpg" alt="Living room" onClick={() => openLightbox('/images/renovation1.jpg')} />
                        <img src="/images/renovation2.jpg" alt="Dining and kitchen" onClick={() => openLightbox('/images/renovation2.jpg')} />
                    </div>
                </section>

                {/* Section 2: Dining and Kitchen */}
                <section className="akebono-garden-feature">
                    <h2>Dining & Kitchen</h2>
                    <p>
                        The dining area includes a counter table where up to four guests can enjoy breakfast or coffee in a relaxed setting.
                    </p>
                    <p>
                        The kitchen is equipped with the latest IH cooktop and tableware for eight guests. Perfect for enjoying home-style meals even while traveling.
                    </p>
                    <h3>Kitchen Amenities</h3>
                    <ul>
                        <li>IH Stove (2 burners)</li>
                        <li>Refrigerator with freezer</li>
                        <li>Microwave, toaster, electric kettle, dish dryer, rice cooker</li>
                        <li>Cookware (pots, frying pans, knives, cutting board, spatula, ladle, etc.)</li>
                        <li>Tableware (plates, bowls, cutlery)</li>
                        <li>Kitchen towels, dish soap, sponge, coffee</li>
                    </ul>
                    <div className="akebono-garden-gallery">
                        <img src="/images/kicthen.jpg" alt="Kitchen view" onClick={() => openLightbox('/images/kicthen.jpg')} />
                        <img src="/images/kicthen2.jpg" alt="Counter area" onClick={() => openLightbox('/images/kicthen2.jpg')} />
                        <img src="/images/kicthen3.jpg" alt="Courtyard from kitchen" onClick={() => openLightbox('/images/kicthen3.jpg')} />
                        <img src="/images/kicthen4.jpg" alt="Tatami room near kitchen" onClick={() => openLightbox('/images/kicthen4.jpg')} />
                    </div>
                </section>

                {/* Section 3: Bath & Toiletries */}
                <section className="akebono-garden-feature">
                    <h2>Bath, Vanity, and Toilets</h2>
                    <p>
                        The bathroom opens to the courtyard, offering a semi-open-air bath experience. A shutter is available for privacy. The spacious vanity accommodates two guests at once.
                    </p>
                    <p>
                        A drum-type washing machine is available, and there are two modern toilets equipped with warm-water bidet functions.
                    </p>
                    <h3>Amenities</h3>
                    <ul>
                        <li>Hair dryer, clothes steamer, laundry detergent</li>
                        <li>Bath towels, face towels, washcloths</li>
                        <li>Shampoo, conditioner, body soap, hand soap</li>
                        <li>Toothbrushes, toothpaste</li>
                        <li>Wi-Fi, air conditioning, yukata robes</li>
                    </ul>
                    <div className="akebono-garden-gallery">
                        <img src="/images/bath1.jpg" alt="Bath space" onClick={() => openLightbox('/images/bath1.jpg')} />
                        <img src="/images/bath2.jpg" alt="Bathroom details" onClick={() => openLightbox('/images/bath2.jpg')} />
                        <img src="/images/bath3.jpg" alt="Bath and garden view" onClick={() => openLightbox('/images/bath3.jpg')} />
                        <img src="/images/bath4.jpg" alt="Tatami room near bath" onClick={() => openLightbox('/images/bath4.jpg')} />
                    </div>
                </section>

                {/* Section 4: Entrance & Accessibility */}
                <section className="akebono-garden-feature">
                    <h2>Entrance and Entry</h2>
                    <p>
                        The main gate features the Akebono noren (fabric curtain), symbolizing welcome and tradition. The front door is managed by a digital key system, eliminating the need to carry keys.
                    </p>
                    <p>
                        This setup allows for smooth, stress-free check-in and check-out.
                    </p>
                </section>

                {/* Lightbox */}
                {lightboxImage && (
                    <div className="lightbox" onClick={() => setLightboxImage(null)}>
                        <span className="lightbox-close">&times;</span>
                        <img src={lightboxImage} alt="Expanded view" className="lightbox-content" />
                    </div>
                )}
            </div>
        </> // ▲▲▲ Wrapped with Fragment <> ▲▲▲

    );
};

export default RenovationEn;